import { useRouteError } from "react-router";
import { Button, ButtonLink } from "@/components/ui/button";

export function RouteError() {
  const error = useRouteError();
  console.error(error);
  return (
    <main className="mx-auto flex max-w-lg flex-col gap-3 px-4 py-24 text-center">
      <h1 className="text-lg font-semibold">This page hit a problem</h1>
      <p className="text-[13px] text-muted">
        Something on it could not be shown. Reload to try again, or go back to the start.
      </p>
      <div className="flex justify-center gap-2">
        <Button onClick={() => window.location.reload()}>Reload</Button>
        <ButtonLink variant="primary" to="/">
          Home
        </ButtonLink>
      </div>
    </main>
  );
}
